import { AddUsersToGroupDialogCtrl, IAddUsersToGroupDialogScope } from '../controllers/AddUsersToGroupDialogCtrl';
import { IGroupInfo } from '../models/IGroupInfo';
import { Module } from '../Module';
import { ModalService, ModalSize } from './ModalService';

export class AddUsersToGroupAction {

  public static $inject = ['ModalService'];

  constructor(
    private modal: ModalService) { }

  public showAddUsersToGroupDialog(group: IGroupInfo): ng.IPromise<any> {

    const dialogInstance = this.modal.open({
      templateUrl: 'addUsersToGroupDialog.html',
      size: ModalSize.medium,
      controller: AddUsersToGroupDialogCtrl,
      resolve: {
        group: () => group
      }
    });

    return dialogInstance.result;
  }
}

Module.instance().service('AddUsersToGroupAction', AddUsersToGroupAction);
